module.exports = __webpack_public_path__ + "media/images/premium/premium_sample-6f649a105c66c0f070e4ffaebf20f19d.jpg";